// extracted by mini-css-extract-plugin
export default {"langSelector":"popover-list_langSelector__HmtHu","langSelectorItem":"popover-list_langSelectorItem__ifMU0"};